import React from 'react';
import '../../pages/LandingPage.css';
import SectionBackground from './SectionBackground';

const useCases = [
  {
    icon: '🏠',
    title: 'First-Time Landlords',
    description: "Use guided templates with common California requirements baked in.",
  },
  {
    icon: '🏢',
    title: 'Multi-Property Owners',
    description: 'Managing 10+ units? Save hours and hundreds of dollars with our streamlined process.',
  },
  {
    icon: '🏘️',
    title: 'Property Managers',
    description: 'White-label option coming soon! Offer California-focused lease drafts to your clients at scale.',
  },
];

const UseCasesSection: React.FC = () => {
  return (
    <SectionBackground className="features" style={{ padding: '80px 16px' }}>
      <div className="container">
        <h2 style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: 60, fontWeight: 700 }}>
          Perfect For Every California Landlord
        </h2>
        <div className="features-grid">
          {useCases.map((useCase, idx) => (
            <div className="feature-card" key={idx} style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '3rem', marginBottom: '20px' }}>{useCase.icon}</div>
              <h3 style={{ fontSize: '1.5rem', marginBottom: '15px', fontWeight: 600 }}>
                {useCase.title}
              </h3>
              <p style={{ color: 'var(--text-light)', lineHeight: 1.8 }}>
                {useCase.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </SectionBackground>
  );
};

export default UseCasesSection; 
